import { render } from "./OnboardingTooltip.vue?vue&type=template&id=6d1bddc8"
import script from "./OnboardingTooltip.vue?vue&type=script&lang=js"
export * from "./OnboardingTooltip.vue?vue&type=script&lang=js"

import "./OnboardingTooltip.vue?vue&type=style&index=0&id=6d1bddc8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QIcon,QBtn});
